import React from "react";
import Topnavbar from "../components/navbar";
import Footer from "../components/footer";
import Brand from "../components/brands/brand";


const Brands = () => {
  return (
    <div className="Home">
      <Topnavbar />
      <Brand/>
      <Footer />
    </div>
  );
};

export default Brands;
